import React, { useCallback, useContext } from 'react';
import { isMobile } from 'react-device-detect';
import { useDebouncedCallback } from '@24i/player-utils-react';
import { PlayerUIContext, PlayerUIContextProvider } from '@24i/player-ui';
import { Container } from './styled';
const CLICK_DELAY = isMobile ? 300 : 0;
const PERCENT_OFFSET_FROM_BORDER_TO_SEEK = 20;
const FULL_PERCENT = 100;
const SEEK_AMOUNT = 10000;
export const WithoutContextPlayerUIContainer = ({ playerInstance, blockingReason, children, className, style, }) => {
    const { state: { isDragSeeking }, } = useContext(PlayerUIContext);
    const [onClickHandlerDebounced, cancelClickHandler] = useDebouncedCallback(() => {
        if (!playerInstance || blockingReason) {
            return;
        }
        const isPaused = playerInstance.paused;
        if (isPaused)
            playerInstance.play();
        if (!isPaused)
            playerInstance.pause();
    }, CLICK_DELAY);
    const onClickHandler = useCallback(() => {
        if (isDragSeeking)
            return;
        if (isMobile)
            return;
        onClickHandlerDebounced();
    }, [playerInstance, isDragSeeking]);
    const onDoubleClickHandler = useCallback((event) => {
        if (isMobile) {
            cancelClickHandler();
            if (isDragSeeking)
                return;
            if (!playerInstance)
                return;
            if ((event.nativeEvent.offsetX / event.target.offsetWidth) * FULL_PERCENT <
                PERCENT_OFFSET_FROM_BORDER_TO_SEEK) {
                playerInstance.backward(SEEK_AMOUNT);
            }
            else if ((event.nativeEvent.offsetX / event.target.offsetWidth) * FULL_PERCENT >
                FULL_PERCENT - PERCENT_OFFSET_FROM_BORDER_TO_SEEK) {
                playerInstance.forward(SEEK_AMOUNT);
            }
        }
        else {
            if (playerInstance) {
                playerInstance.fullscreen = !playerInstance.fullscreen;
            }
            if (event)
                event.stopPropagation();
        }
    }, [playerInstance, isDragSeeking]);
    return (React.createElement(Container, { className: `PlayerUIContainer ${className}`, "data-test": "PlayerUIContainer-Container", id: "PlayerUIContainer-Container", onClick: onClickHandler, onDoubleClick: onDoubleClickHandler, style }, children));
};
WithoutContextPlayerUIContainer.displayName = 'WithoutContextPlayerUIContainer';
export const PlayerUIContainer = (props) => (React.createElement(PlayerUIContextProvider, null,
    React.createElement(WithoutContextPlayerUIContainer, Object.assign({}, props))));
PlayerUIContainer.displayName = 'PlayerUIContainer';
PlayerUIContainer.defaultProps = {
    className: '',
    style: null,
};
//# sourceMappingURL=index.js.map